export function compareCategories(a, b) {
    if (a.hasH2H && b.hasH2H) {
        return compareBySortOrder(a, b);
    }
    return compareByH2H(a, b);
}
export function compareBySortOrder(a, b) {
    return a.sortOrder - b.sortOrder;
}
function compareByH2H(a, b) {
    if (a.hasH2H && !b.hasH2H) {
        return -1;
    }
    if (!a.hasH2H && b.hasH2H) {
        return 1;
    }
    return compareBySortOrder(a, b);
}
//# sourceMappingURL=sortCategories.js.map